import React from "react";
import { HStack, VStack } from "@chakra-ui/react";
import { SelectedDeliveryOption } from "../../types";
import { ActionPillButton } from "./ActionPillButton";
import { BuyTimeControl } from "./BuyTimeControl";

export interface SplitActionPillsProps {
  selection: SelectedDeliveryOption | undefined;
  isExpired: boolean;
  buyTimeValue: string;
  isBuyTimeSelected: boolean;
  onHold: () => void;
  onCancel: () => void;
  onBuyTimeToggle: () => void;
  onBuyTimeValueChange: (value: string) => void;
}

export const SplitActionPills: React.FC<SplitActionPillsProps> = ({
  selection,
  isExpired,
  buyTimeValue,
  isBuyTimeSelected,
  onHold,
  onCancel,
  onBuyTimeToggle,
  onBuyTimeValueChange,
}) => (
  <VStack align="flex-end" spacing={1}>
    <HStack spacing={3} align="center">
      <ActionPillButton
        label="HOLD"
        isSelected={selection?.customerAction === "hold"}
        onClick={onHold}
        isDisabled={isExpired}
        colorScheme="gray"
      />
      <ActionPillButton
        label="CANCEL"
        isSelected={selection?.customerAction === "cancel"}
        onClick={onCancel}
        isDisabled={isExpired}
        colorScheme="orange"
      />
      <BuyTimeControl
        buyTimeValue={buyTimeValue}
        isBuyTimeSelected={isBuyTimeSelected}
        isExpired={isExpired}
        onToggle={onBuyTimeToggle}
        onValueChange={onBuyTimeValueChange}
      />
    </HStack>
  </VStack>
);
